// Packages
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

// Components
import { SolidButton } from 'components/buttons/SolidButton';
import { OutlineButton } from 'components/buttons/OutlineButton';
import ModalContainer from 'components/ModalContainer';

const UnSavedConfirmModalContainer = ({
  isOpen,
  discardCallback,
  applyCallback,
}) => {
  const theme = useTheme();

  return (
    <>
      <ModalContainer display={isOpen} modalWidth="500px">
        <Box sx={{ padding: '0 10px', textAlign: 'center' }}>
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontFamily: theme.typography.fontFamily,
              fontSize: theme.typography.customFontSize[5],
              fontWeight: theme.typography.customFontWeight[3],
              overflowWrap: 'anywhere',
              marginBottom: 1,
            }}
          >
            Unapplied Changes
          </Typography>

          <Typography>You have changes that haven't been applied yet. If you leave or proceed now, these changes will be lost. Would you like to apply them now?</Typography>

          <Box
            sx={{
              marginTop: '20px',
              paddingTop: '20px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <OutlineButton sx={{ marginRight: '20px' }} width="100px" height="32px" onClick={discardCallback}>
              Discard
            </OutlineButton>
            <SolidButton width="100px" height="32px" onClick={applyCallback}>
              Apply
            </SolidButton>
          </Box>
        </Box>
      </ModalContainer>
    </>
  );
};

export default UnSavedConfirmModalContainer;
